<select
  class="form-select language-switcher-select"
  [formControl]="langSelect"
  (change)="changeLang(langSelect.value)"
  aria-label="Select language"
>
  <option *ngFor="let language of languages" value="{{language.value}}">{{language.label | translate}}</option>
</select>
